export const NUM_CURATED_TRAILS = 400; // thousand
export const NUM_USERS = 60; // million
export const LOGGED_DISTANCE = 1528876; // meters
